import { AppBar, Button, Divider, Grid, Tab, Tabs, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TabPanel from './TabPanel';
import { marginBottomForBreadCrumb } from '../../config/styles';
import ListSimulationProfiles from '../molecules/simulations/ListSimulationProfiles';
import ProfileSelector from '../molecules/simulations/ProfileSelector';
import DeleteSimulationProfileAlert from '../molecules/alerts/DeleteSimulationProfileAlert';
import { handleSnackBar, invokeGetService, invokePostService, setFocusElement, setInnerScreenRender, setReRender, setTabOnFocus, toggleRightDrawer } from '../../store/global/actions';
import ContextGenerator from '../molecules/simulations/ContextGenerator';
import Breadcrumb from '../atoms/breadcrumb';
import CreateTestcase from '../molecules/simulations/CreateTestcase';
import TransactionSelector from '../molecules/simulations/TransactionSelector';
import NextPrevious from '../atoms/buttons/NextPrevious';
import DelegateSelector from '../molecules/simulations/DelegateSelector';
import { getDetailsFromUrl } from '../../services/blueprint';
import CreateBack from '../atoms/buttons/CreateBack';
import { useHistory } from "react-router-dom";
import { getLogRedirectionData } from '../../store/global/selectors';
import CompactAlert from '../molecules/logs/LogRedirectionAlert';

export default function SimulationTestcases({ element }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [tabActive, setTabActive] = useState(element.action === 'add_transaction' ? 'transaction' : 'simulationInfo');
  const [openTab, setOpenTab] = useState(0);
  const [transactions, setTransactions] = useState([]);
const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedDelegates, setSelectedDelegates] = useState([]);
  const [testcaseData, setTestcaseData] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [errors, setError] = useState(null);
  const detailsBC = [
    { label: 'Testsuite', url: null },
    { label: element?.activeTestsuite, url: null },
    { label: 'Testcase', url: null },
    { label: element.name, url: null },
  ];
  const [action, setAction] = useState(0);
  const logRedirectionData = useSelector(getLogRedirectionData);


  const onTransactionNext = () => {
    if (selectedTransactions.length < 1) {
      const validateError = document.getElementById("transaction-validation-error");
      if (validateError === null) {
        document.getElementById(`simulation[simulation][0][transaction]`)?.insertAdjacentHTML("afterend", `<p id="transaction-validation-error" class="text text-danger validation-error" >Please select transaction</p>`);
      }
      return;
    } else {
      const validateError = document.getElementById("transaction-validation-error");
      if (validateError) {
        validateError.remove();
      }
    }
    setOpenTab(2)
  }


  // to close the 'add profile' page, if the tab is changed from Profile
  if ((action.action == "add_profile" || action.action == "edit_profile") && openTab != 4) {
    setAction({});
  }

  useEffect(() => {
    const tabIndicators = document.getElementsByClassName('MuiTabs-indicator');
    if (tabActive == 'simulationInfo') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '0px';
        tabIndicators[0].style.width = '160px';
      }
    }
    if (tabActive == 'transaction') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '160px';
        tabIndicators[0].style.width = '160px';
      }
      const transactionBtn = document.getElementById('transaction_tab');
      if (transactionBtn) transactionBtn.classList.add('Mui-selected');
    }
    if (tabActive == 'delegate') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '320px';
        tabIndicators[0].style.width = '160px';
      }
      const transactionBtn = document.getElementById('delegate_tab');
      if (transactionBtn) transactionBtn.classList.add('Mui-selected');
    }
  }, [tabActive]);

  const onClose = () => {
    setAction({});
  };

  const onCancel = () => {
    setAction({});
    dispatch(toggleRightDrawer());
  };

  const onCompletion = (action, type, message) => {
    switch (action) {
      case 'add':
        dispatch(handleSnackBar({ open: true, message: message ? message : 'Profile added', severity: 'success' }));
        break;

      case 'delete':
        dispatch(handleSnackBar({ open: true, message: message ? message : 'Profile deleted', severity: 'success' }));
        break;
    }
    setAction({});
  };

  const decideTabActive = (value) => {
    if (value == 3 || value == 4) {
      setTabActive('simulationInfo');
    }
  };

  const onCreateOrUpdate = (mode) => {
    const { entityId } = getDetailsFromUrl()

    if (selectedDelegates.length < 1) {
      dispatch(handleSnackBar({ open: true, message: 'Must select delegate to create simulation', severity: 'error' }));
      return;
    }
    setIsCreating(true);

    const testcase = {
      name: testcaseData.name,
      description: testcaseData.description,
      transactions: selectedTransactions,
      testsuite_id: entityId,
      delegates: selectedDelegates.map((delegate) => delegate._id)
    };


    if (mode === 'update') {
      dispatch(invokePostService('updateTestcase', testcase, [element.id])).then(response => {
        setIsCreating(false);
        if (response.status && response.data !== null) {
          dispatch(setInnerScreenRender());
          dispatch(toggleRightDrawer());
          dispatch(setFocusElement({}));
          dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
          dispatch(setReRender())
        } else {
          if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
            setOpenTab(0)
            response?.errors?.forEach(error => {
              setError(error.name, { message: error.message });
            });
          } else if (response?.message) {
            dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
          }
        }
      });

      return true
    }

    dispatch(invokePostService('createTestcase', testcase, [])).then(response => {
      setIsCreating(false);
      if (response.status && response.data !== null) {
        const { slug, blueprintId } = getDetailsFromUrl();
        history.push(`/blueprint/${slug}/${blueprintId}/testsuite/${response.data?.testcase?.testsuite_id}?testcase=${response.data?.testcase?._id}`);
        dispatch(toggleRightDrawer());
        dispatch(setFocusElement({}));
        dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
        dispatch(setReRender());
      } else {
        dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }));

        if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
          //setOpenTab(0)
          response?.errors?.forEach(error => {
            setError({ name: error.name, message: error.message });
          });
        } else if (response?.message) {
          dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
        }
      }
    });
  }


  useEffect(() => {
    if (element?.action === 'edit_context') {
      // console.log("edit_context")
      setOpenTab(3)
    } else if (element?.action === 'profile_tab') {
      // console.log("profile_tab")
      setOpenTab(4)
    } else {
      // console.log("edit")
      setOpenTab(0)
    }
  }, [element?.action]);

  useEffect(() => {
    setIsFetching(true);
    if (element?.id) {
      Promise.all([dispatch(invokeGetService('getAllTransaction', {})),
      dispatch(invokeGetService('getTestcaseData', [element.id]))
      ]).then(([response, testcaseDetails]) => {
        if (testcaseDetails.status == true) {
          setTestcaseData({
            name: testcaseDetails?.data?.testcase.name,
            description: testcaseDetails?.data?.testcase.description,
          });

          const simulationTransactions = testcaseDetails?.data?.testcaseTransactions.filter(item => !item.parent_id).map(item => {
            return { _id: item.transaction_id, simulationTransactionId: item._id, order: item.order, description: item?.description ? item.description : '' };
          });
          simulationTransactions.sort((a, b) => a.order - b.order)
          setSelectedTransactions(simulationTransactions);
          const delegates = testcaseDetails?.data?.testcase?.delegates.map(item => {
            return { _id: item.id }
          });
          setSelectedDelegates(delegates);
        } else {
          if (testcaseDetails?.code === 255) {
            dispatch(toggleRightDrawer());
            dispatch(setFocusElement({}));
          }
        }
        if (response.status == true) {
          const filteredTransactions = response.data?.filter(transaction => transaction.type == 7);
          
          setTransactions(filteredTransactions);
        }
        setIsFetching(false);
      });
    } else {
      dispatch(invokeGetService('getAllTransaction', {})).then((response) => {
        if (response.status == true) {
          const filteredTransactions = response.data?.filter(transaction => transaction.type == 7);
          
          setTransactions(filteredTransactions);
        }
        setIsFetching(false);
      });
    }
  }, [element?.action])

  return (
    <>
      <AppBar position="static">
        <Tabs
          value={openTab}
          onChange={(e, v) => {
            dispatch(setTabOnFocus(v));
            setOpenTab(v);
            decideTabActive(v);
          }}
          aria-label="TestcaseTabs">
          <Tab label="Testcase" data-ui-tour-id="testcase-tab" id="simulation_info_tab" />
          <Tab label="Transactions" data-ui-tour-id="transaction-tab" disabled={openTab < 1 && !testcaseData?.name} id="transaction_tab" />
          <Tab label="Delegates" data-ui-tour-id="delegates-tab" disabled={((openTab < 2 || !selectedTransactions?.[0]?.clusterlets) && element.action !== 'edit')} id="delegate_tab" />
          <Tab label="Context" data-ui-tour-id="context-tab" id="context_tab" disabled={element?.action === 'create'} />
          <Tab label="Profile" data-ui-tour-id="profile-tab" id="profile_tab" disabled={element?.action === 'create'} />
        </Tabs>
      </AppBar>

      <TabPanel value={openTab} index={0}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <Breadcrumb items={detailsBC} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        <CreateTestcase errorProps={errors} type={element.action} testcaseId={element.id} isFetching={isFetching} setIsFetching={setIsFetching} setOpenTab={setOpenTab} setTestcaseData={setTestcaseData} testcaseData={testcaseData} onClose={onCancel} />
      </TabPanel>

      <TabPanel value={openTab} index={1}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <Breadcrumb items={[...detailsBC, { label: 'Transactions', url: null }]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        <TransactionSelector transactions={transactions} testcaseId={element.id} type={element.action} selectedTransactions={selectedTransactions} setSelectedTransactions={setSelectedTransactions} isFetching={isFetching} onClose={onCancel} setIsFetching={setIsFetching} setSelectedDelegates={setSelectedDelegates} />

        <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex' }}>
          {element.action !== "edit" &&
            <NextPrevious onNext={onTransactionNext} onPrevious={() => setOpenTab(0)} nextDisable={isFetching} />
          }
        </Grid>

      </TabPanel>

      <TabPanel value={openTab} index={2}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <Breadcrumb items={[...detailsBC, { label: 'Delegates', url: null }]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        <DelegateSelector forwaredTransactions={selectedTransactions} testcaseId={element?.id} type={element.action} isFetching={isFetching} setIsFetching={setIsFetching} setSelectedDelegates={setSelectedDelegates} selectedDelegates={selectedDelegates} onClose={onCancel} />

        <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex', marginTop: '2rem' }} >
          {
            !(element?.action === 'edit' || element?.action === 'edit_context' || element?.action === 'profile_tab') &&
              <CreateBack onCreate={onCreateOrUpdate} onBack={() => setOpenTab(1)} createDisable={isCreating || isFetching} content={isCreating ? 'Creating..' : isFetching ? 'Loading..' : 'Create'} />
          }
        </Grid>
      </TabPanel>

      <TabPanel value={openTab} index={3}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <Breadcrumb items={[...detailsBC, { label: 'Context', url: null }]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {
          (logRedirectionData?.entity === "testcase" && logRedirectionData.entityId === element.id) && logRedirectionData.tabOnfocus === 3 ?
            <CompactAlert severity={logRedirectionData?.level}>{logRedirectionData?.message}</CompactAlert>
          :
          null
        }
        <ContextGenerator entityId={element?.id} type='testcase' onCancel={onCancel} />
      </TabPanel>

      <TabPanel value={openTab} index={4}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <Breadcrumb items={[...detailsBC, { label: 'Profile', url: null }]} />
          </Grid>

          {Object.keys(action).length === 0 && (
            <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title="Create button">
                <span>
                  <Button id="add-profile" onClick={(e) => setAction({ action: 'add_profile' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }}>
                    Add Profile
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {Object.keys(action).length === 0 && <ListSimulationProfiles entityId={element?.id} type="testcase" setAction={setAction} />}
        {action.action === 'add_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} entityId={element?.id} type='testcase' />}
        {action.action === 'edit_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} action={action} entityId={element?.id} type='testcase' />}
        {action.action === 'delete_profile' && <DeleteSimulationProfileAlert title='Delete Testcase Profile' entityId={element?.id} testsuiteId={element?.testsuiteId} type='testcase' onClose={onClose} onCompletion={onCompletion} element={action.item} itemName={action?.name} />}
      </TabPanel>
    </>
  );
}
